
import React, { useMemo, useState } from 'react';
import { Button, Descriptions, Input, Space } from "antd";
import { EditOutlined } from '@ant-design/icons';
import { ShopifyProduct } from '../../store/shopifyProductsSlice';
import DOMPurify from 'dompurify';
import EditShopifyProductDescriptionModal from './EditShopifyPorductDescriptionModal';

const { Search } = Input
interface ShopifyProductDetailDescriptionProps {
    shopifyProduct: ShopifyProduct | null;
    handleDiscard: (type: "Description" | "Title") => void;
}

const ShopifyProductDetailDescription: React.FC<ShopifyProductDetailDescriptionProps> = ({ shopifyProduct, handleDiscard }) => {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editKey, setEditKey] = useState<"Description" | "Title">('Description')
    const [editValue, setEditValue] = useState<string>('')


    const handleEditClick = (editKey: "Description" | "Title", editValue: string | undefined) => {
        if (!editValue) return
        setEditKey(editKey);
        setEditValue(editValue);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setEditValue("");
        setIsModalOpen(false);
    }

    const descriptionItems = useMemo(() => {
        if (shopifyProduct) {
            return [
                {
                    key: 1,
                    label: 'Title',
                    children: shopifyProduct.title,
                    span: 12
                },
                {
                    key: 2,
                    label: <Space direction="horizontal" size="small" style={{ display: 'flex' }}>
                        Rec. Title
                        <Button type="text" onClick={() => handleEditClick('Title', shopifyProduct.generation?.title)} style={{ marginLeft: 8 }} icon={<EditOutlined />} />
                        <Button size="small" type="link" danger onClick={() => handleDiscard("Title")}>
                            Discard
                        </Button>
                    </Space>,
                    children: shopifyProduct.generation?.title,
                    span: 12
                },
                {
                    key: 3,
                    label: "Description",
                    children: (
                        <div
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(shopifyProduct.descriptionHtml || "") }}
                        />
                    ),
                    span: 12
                },
                {
                    key: 4,
                    label: (
                        <Space direction="horizontal" size="small" style={{ display: 'flex' }}>
                            Rec. Description
                            <Button type="text" onClick={() => handleEditClick('Description', shopifyProduct.generation?.descriptionHtml)} style={{ marginLeft: 8 }} icon={<EditOutlined />} />
                            <Button size="small" type="link" danger onClick={() => handleDiscard("Description")}>
                                Discard
                            </Button>
                        </Space>
                    ),
                    children: (
                        <div
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(shopifyProduct.generation?.descriptionHtml ?? "") }}
                        />
                    ),
                    span: 12
                },
                {
                    key: 5,
                    label: "Reasoning",
                    span: 24,
                    children: (() => {
                        const reasonData = shopifyProduct.generation?.reasoning;

                        // If it's an array, render a list:
                        if (Array.isArray(reasonData)) {
                            if (reasonData.length === 0) {
                                return <div>No reasons provided.</div>;
                            }
                            return (
                                <ul>
                                    {reasonData.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            );
                        }

                        // Otherwise, treat it as a string (or null/undefined), sanitize, and render:
                        const sanitizedHtml = DOMPurify.sanitize(reasonData ?? "");
                        return (
                            <div
                                dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
                            />
                        );
                    })(),
                }
            ]
        }
        return []
    }, [shopifyProduct]);

    return (
        <div>
            <Descriptions
                bordered
                size="small"
                column={24}
                items={descriptionItems}
                labelStyle={{ width: "50%", fontSize: 14 }}
                contentStyle={{ width: "50%", fontSize: 14 }}
                layout="vertical"
            />
            <EditShopifyProductDescriptionModal
                open={isModalOpen}
                handleClose={handleModalClose}
                value={editValue}
                fieldToUpdate={editKey}
                shopifyProduct={shopifyProduct}
            />
        </div>
    )
};


export default ShopifyProductDetailDescription;
